import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
  selector: 'app-information-tooltip',
  imports: [CommonModule, TooltipModule],
  templateUrl: './information-tooltip.component.html',
  styleUrls: ['./information-tooltip.component.scss'],
})
export class InformationTooltipComponent implements OnInit {
  @Input() tooltipIcon: string;
  @Input() iconSize: string;
  @Input() tooltipData: string;
  @Input() tooltipClass: string;
  @Input() iconColor: string;

  constructor() {}
  // TODO: Remove ngOnInit if not needed in future review
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}
}
